module.exports = __webpack_public_path__ + "assets/phone.e10b7713.svg";